import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { Box, Columns, Column, Text, Strong } from "braid-design-system";
import * as Apollo from "@apollo/client";
import { gql } from "@apollo/client";
import { useEmployerHeaderContext } from "../../../EmployerFooter/EmployerFooter.mjs";
import { csToggle } from "./ImpersonationBanner.css.mjs";
const defaultOptions = {};
const CustomerServiceViewUrlDocument = gql`
  query CustomerServiceViewUrl($headerFooterInput: HeaderFooterContextInput) {
    headerFooterContext {
      identityContext {
        act(input: $headerFooterInput) {
          csToggleHref
        }
      }
    }
  }
`;
function useCustomerServiceViewUrlLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(CustomerServiceViewUrlDocument, options);
}
const actorDisplayText = (email) => {
  let displayText = "Operator";
  if (email && email.indexOf("@") > -1) {
    displayText = email.substring(0, email.indexOf("@"));
  }
  return displayText;
};
const actAsDisplayText = (email, additionalInfo) => /* @__PURE__ */ jsxs(Fragment, { children: [
  email,
  additionalInfo ? /* @__PURE__ */ jsxs(Fragment, { children: [
    " ",
    /* @__PURE__ */ jsxs("span", { "data-hj-masked": "true", "data-dd-privacy": "mask", children: [
      "(",
      additionalInfo,
      ")"
    ] })
  ] }) : null
] });
const ImpersonationBanner = () => {
  const { impersonationContext: context } = useEmployerHeaderContext();
  const [getCustomerServiceViewUrl] = useCustomerServiceViewUrlLazyQuery();
  if (!context) {
    return null;
  }
  const { operatorEmail, isCsView, additionalInfo, subjectEmail } = context;
  const actor = actorDisplayText(operatorEmail);
  const actAs = actAsDisplayText(subjectEmail, additionalInfo);
  const onCsToggleClick = async () => {
    var _a, _b, _c;
    const location = {
      pathname: "/",
      search: ""
    };
    if (typeof window !== "undefined") {
      location.pathname = window.location.pathname;
      location.search = window.location.search;
    }
    const { data } = await getCustomerServiceViewUrl({
      variables: {
        headerFooterInput: {
          location
        }
      }
    });
    if (((_c = (_b = (_a = data == null ? void 0 : data.headerFooterContext) == null ? void 0 : _a.identityContext) == null ? void 0 : _b.act) == null ? void 0 : _c.csToggleHref) && typeof window !== "undefined") {
      window.location.href = data.headerFooterContext.identityContext.act.csToggleHref;
    }
  };
  return /* @__PURE__ */ jsx(
    Box,
    {
      paddingX: "gutter",
      background: "brandAccent",
      alignItems: "center",
      paddingY: "small",
      textAlign: "center",
      children: /* @__PURE__ */ jsxs(
        Columns,
        {
          space: "small",
          collapseBelow: "tablet",
          alignY: "center",
          align: "center",
          children: [
            /* @__PURE__ */ jsx(Column, { width: "content", children: /* @__PURE__ */ jsxs(Text, { size: "small", children: [
              /* @__PURE__ */ jsx(Strong, { data: { "dd-privacy": "mask", "hj-masked": true }, children: actor }),
              " ",
              "is impersonating ",
              actAs
            ] }) }),
            /* @__PURE__ */ jsx(Column, { width: "content", children: /* @__PURE__ */ jsx(Text, { size: "small", weight: "medium", children: /* @__PURE__ */ jsx(
              Box,
              {
                component: "button",
                display: "inlineBlock",
                paddingX: "small",
                paddingY: "xxsmall",
                marginLeft: "small",
                className: csToggle,
                onClick: onCsToggleClick,
                cursor: "pointer",
                children: isCsView ? "Switch to user view" : "Switch to CS view"
              }
            ) }) })
          ]
        }
      )
    }
  );
};
export {
  ImpersonationBanner
};
